export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ussd.vue?vue&type=template&id=9e63bb8a"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/ussd.vue?vue&type=template&id=9e63bb8a
// module id = kfgq
// module chunks = 0